const Footer = () => {
  return (
    <footer className="bg-amber-100 p-3 text-center font-bold">
      Developed by Parth
    </footer>
  );
};

export { Footer };
